export const build = { date:"2026-05-07.1802", stage:"alpha" }
